import d3 from 'd3'
import {bootstrap} from '../bootstrap/bootstrap'
import {GlyphChart, ClassedGlyphChart, MeanderingGlyphChart, AttributionTargetChart, FootTrafficChart} from './charts'
import {Glyph, HexagonGlyph, ClassedGlyph, ClassedFocusedGlyph} from './glyphs'
import {initializeChart} from './initialize'

const customersGlyphCharts = Array.from(document.getElementsByClassName('glyph-chart--customers'))
const scaleGlyphCharts = Array.from(document.getElementsByClassName('glyph-chart--scale'))
const targetGlyphCharts = Array.from(document.getElementsByClassName('glyph-chart--target'))
const attributionGlyphCharts = Array.from(document.getElementsByClassName('glyph-chart--attribution'))
const footTrafficGlyphCharts = Array.from(document.getElementsByClassName('glyph-chart--foot-traffic'))
const heroes = Array.from(document.getElementsByClassName('glyph-chart--hero'))
const pinpointClassWeights = [
  {class: 'glyph', weight: 0.55},
  {class: 'glyph glyph--accent', weight: 0.45}
]
const attributionClassWeights = [
  {class: 'glyph', weight: 0.45},
  {class: 'glyph glyph--accent', weight: 1.0}
]
const heroClassWeights = [
  {class: 'glyph', weight: 0.2},
  {class: 'glyph glyph--red', weight: 0.4},
  {class: 'glyph glyph--blue', weight: 0.6},
  {class: 'glyph glyph--yellow', weight: 0.8},
  {class: 'glyph glyph--accent', weight: 1.0}
]
const footTrafficClassWeights = [
  {class: 'glyph', weight: 0.2},
  {class: 'glyph glyph--red', weight: 0.4},
  {class: 'glyph glyph--blue', weight: 0.6},
  {class: 'glyph glyph--yellow', weight: 0.8},
  {class: 'glyph glyph--accent', weight: 1.0}
]
const footTrafficFocusPoints = [
  {x: 25, y: 123},
  {x: 25, y: 123},
  {x: 50, y: 123},
  {x: 75, y: 123},
  {x: 75, y: 123}
]
bootstrap(customersGlyphCharts, initializeChart, GlyphChart, d3, HexagonGlyph, 0.28, 4, -25)
bootstrap(scaleGlyphCharts, initializeChart, GlyphChart, d3, Glyph, 0.28, 20, -5, 750)
bootstrap(targetGlyphCharts, initializeChart, ClassedGlyphChart, d3, ClassedGlyph,
          pinpointClassWeights, 0.28, 20, -5, 750)
bootstrap(attributionGlyphCharts, initializeChart, AttributionTargetChart, d3, ClassedGlyph,
          attributionClassWeights, 0.20, 40, -4, 750)
bootstrap(footTrafficGlyphCharts, initializeChart, FootTrafficChart, d3,
          ClassedFocusedGlyph, footTrafficClassWeights, 0.15, 25, 0, 250, 0.0000001, footTrafficFocusPoints)
bootstrap(heroes, initializeChart, MeanderingGlyphChart, d3, ClassedGlyph,
          heroClassWeights, 0.075, 25, 0, -40, 75)
